import { styled } from '@glitz/react';

export const ProductCardWrapper = styled.div({
  minWidth: 0,
  borderRadius: '8px 8px 0px 0px',
  overflow: 'hidden',
});